import React                                                                                                         from "react";
import { Bar }                                                                                                       from "react-chartjs-2";
import { BarElement, CategoryScale, Chart as ChartJS, Legend, LinearScale, Title, Tooltip, ChartData, ChartOptions } from "chart.js";

// Register the necessary Chart.js components
ChartJS.register(CategoryScale, LinearScale, BarElement, Legend, Title, Tooltip);

interface DashStackedBarChartProps {
    data: any,
    title: string,
}

const DashStackedBarChart: React.FC<DashStackedBarChartProps> = ( props ) => {

    const options: ChartOptions<"bar"> = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: true,
            },
            title: {
                display: true,
                text: props.title,
            },
            datalabels: {
                display: false,
            },
        },
        scales: {
            x: {
                stacked: true,
            },
            y: {
                stacked: true,
            },
        },
    };

    return (
        <>
             {props.data?.datasets?.length> 0 && (<Bar data={props.data} options={options} />)}
        </>
    );
};

export default DashStackedBarChart;
